import { constant } from "../../../constants/pages";
import handshake from "../../../assets/images/pages/handshake.jpg";
import handshakepld from "../../../assets/images/imgplaceholders/hanshakepld.png";
import PreloadImage from "../ImagePreloader/ImagePreloader";

// Separate the feature card into its own component for better organization
const FeatureCard = ({
  title,
  content,
  img,
}: {
  title: string;
  content: string;
  img: string;
}) => (
  <div className="flex items-center gap-3 p-4 bg-customyellow rounded-lg shadow-sm">
    <div className="rounded-lg flex justify-center items-center">
      <img
        alt={title}
        src={img}
        className="size-8 object-cover aspect-square"
      />
    </div>
    <div>
      <h4 className="font-semibold text-primary-900">{title}</h4>
      <p className="text-primay-900">{content}</p>
    </div>
  </div>
);

export default function WhyChooseUs() {
  return (
    <section className="relative py-28 bg-primary-900">
      <div className="max-w-7xl mx-auto px-6 xl:px-0">
        <div className="grid lg:grid-cols-2 gap-20 items-center">
          {/* Image Section */}
          <div className="relative">
            <PreloadImage
              imgSrc={handshake}
              imgAlt="Business Handshake"
              imgClassName="w-full h-auto rounded-2xl shadow-md object-cover aspect-[4/3]"
              placeholderSrc={handshakepld}
            />
          </div>

          {/* Content Section */}
          <div>
            <div className="inline-flex items-center gap-2 bg-customyellow px-4 py-2 rounded-full shadow-md mb-8 ">
              <span className="flex h-2 w-2 relative">
                <span className="animate-ping absolute inline-flex h-full w-full rounded-full bg-primary-800 opacity-75"></span>
                <span className="relative inline-flex rounded-full h-2 w-2 bg-primary-800"></span>
              </span>
              <h4 className="text-sm font-medium text-primary-800">
                Why Choose Us?
              </h4>
            </div>
            <p className="text-3xl font-bold mb-6 capitalize text-white">
              We deliver the high quality and results you need.
            </p>

            {/* Features Grid */}
            <div className="space-y-6">
              {constant.whys.map((point) => (
                <FeatureCard
                  key={point.title}
                  title={point.title}
                  content={point.content}
                  img={point.img}
                />
              ))}
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
